import { api } from '../api';

export const create = (dicoms: FormData) => api.post('/dicom', dicoms);
